import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Collapse, IconButton, TableCell, TableRow, Table, TableBody, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const Row = ({ row, onActionClick }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {/* Main Row */}
      <TableRow sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: '#f9f9f9', borderRadius: '10px' }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon sx={{ color: '#1976d2' }} /> : <KeyboardArrowDownIcon sx={{ color: '#1976d2' }} />}
          </IconButton>
        </TableCell>
        <TableCell sx={{ fontWeight: 'bold', color: '#333'}}>{row.event_name}</TableCell>
        <TableCell align="center">
          <IconButton onClick={() => onActionClick(row)}>
            <MoreVertIcon />
          </IconButton>
        </TableCell>
      </TableRow>

      {/* Variations */}
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={3}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, backgroundColor: '#fafafa', borderRadius: '10px', p: 1 }}>
              <Typography variant="subtitle1" gutterBottom sx={{ color: '#1976d2' }}>
                Variations
              </Typography>
              <Table size="small" aria-label="variations">
                <TableBody>
                  {row.product_variants && row.product_variants.map((variant) => (
                    <TableRow key={variant.product_variant_id}>
                      <TableCell sx={{ color: '#333' }}>{variant.name}</TableCell>
                      <TableCell align="right">
                        <IconButton onClick={() => onActionClick({
                          ...variant,
                          event_name: `${row.event_name} - ${variant.name}`
                        })}>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

Row.propTypes = {
  row: PropTypes.shape({
    event_name: PropTypes.string.isRequired,
    woocommerce_product_id_int: PropTypes.number.isRequired,
    product_variants: PropTypes.arrayOf(
      PropTypes.shape({
        product_variant_id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        woocommerce_product_id_int: PropTypes.number.isRequired,
      })
    ),
  }).isRequired,
  onActionClick: PropTypes.func.isRequired,
};

export default Row;
